import React, { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Container, Row, Col, Button, Label, Card, CardBody, CardHeader } from "reactstrap"
import { toast } from "react-toastify"
import axios from "axios"

const OTPProviderSettings = () => {
  const [otpProvider, setOtpProvider] = useState("almadar")
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken")
        const response = await axios.get(
          `${process.env.REACT_APP_WEB_APP_URL}/api/web/otp-provider-settings`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        if (response.status === 200 && response.data?.data?.otp_provider) {
          setOtpProvider(response.data.data.otp_provider)
        }
      } catch (error) {
        console.error(error)
        toast.error("Failed to load OTP provider settings")
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const response = await axios.post(
        `${process.env.REACT_APP_WEB_APP_URL}/api/web/otp-provider-settings`,
        { otp_provider: otpProvider },
        {
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (response.status === 200) {
        toast.success("OTP provider updated successfully", { autoClose: 3000 })
      } else {
        toast.error(response?.data?.message || "Failed to update OTP provider", { autoClose: 3000 })
      }
    } catch (error) {
      console.error(error)
      toast.error(error?.response?.data?.message || "Failed to update OTP provider", { autoClose: 3000 })
    }
  }

  document.title = "OTP Provider Settings | Moeen"

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="OTP Provider Settings" />
        {loading ? (
          <Skeleton count={6} height={40} />
        ) : (
          <div className="page-content">
            <Container fluid>
              <Row className="mb-4">
                <Col lg={12}>
                  <h4 className="mb-2">SMS OTP Provider</h4>
                  <p className="text-muted">
                    Choose which SMS provider is used to send and verify OTP codes (login, registration, etc.).
                  </p>
                </Col>
              </Row>

              <Row>
                <Col lg={8}>
                  <Card>
                    <CardHeader className="bg-primary text-white">
                      <h5 className="card-title mb-0">
                        <i className="mdi mdi-message-text me-2"></i>
                        Fournisseur OTP SMS
                      </h5>
                    </CardHeader>
                    <CardBody>
                      <Row className="mb-3">
                        <Col md={8}>
                          <Label className="form-label">Provider</Label>
                          <select
                            className="form-select form-select-lg"
                            value={otpProvider}
                            onChange={(e) => setOtpProvider(e.target.value)}
                            style={{ maxWidth: 280 }}
                          >
                            <option value="almadar">ALMADAR</option>
                            <option value="rasael">Rasael Almasafa</option>
                          </select>
                          <div className="form-text">
                            ALMADAR or Rasael Almasafa — used for send OTP and verify OTP (login flow).
                          </div>
                        </Col>
                      </Row>

                      <div className="text-end mt-4">
                        <Button color="primary" className="px-4" onClick={handleSave}>
                          <i className="mdi mdi-content-save me-2"></i>
                          Save
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </div>
    </div>
  )
}

export default OTPProviderSettings
